import { DateTime } from "luxon";

import { FirstListedBucket } from "../models/listingOptimisation/IListingInsights";

// The age bands the eBay Optimisation queue triages on, by the FIRST listing date. Under 30 days
// eBay still treats a listing as fresh; past 180 it is the long tail that is not selling.
export const FRESH_LISTING_DAYS = 30;
export const STALE_LISTING_DAYS = 90;
export const LONG_TAIL_LISTING_DAYS = 180;

export type ListingAgeTone = "fresh" | "stale" | "old" | "longTail";

/** Whole days between an API date and now (UTC). Null for a missing or unparseable date; never negative. */
export function daysSince(iso: string | null | undefined, now: DateTime = DateTime.now()): number | null {
  if (!iso) return null;
  const parsed = DateTime.fromISO(iso, { zone: "utc" });
  if (!parsed.isValid) return null;
  const days = Math.floor(now.diff(parsed, "days").days);
  return days < 0 ? 0 : days;
}

/** The listings-query bucket an age falls in, matching ListingAgeRules on the API. */
export function firstListedBucket(days: number | null): FirstListedBucket | null {
  if (days == null) return null;
  if (days < FRESH_LISTING_DAYS) return "under30";
  if (days < STALE_LISTING_DAYS) return "d30to90";
  if (days < LONG_TAIL_LISTING_DAYS) return "d90to180";
  return "over180";
}

export function listingAgeTone(days: number | null): ListingAgeTone | null {
  const bucket = firstListedBucket(days);
  switch (bucket) {
    case "under30":
      return "fresh";
    case "d30to90":
      return "stale";
    case "d90to180":
      return "old";
    case "over180":
      return "longTail";
    default:
      return null;
  }
}

export const FIRST_LISTED_BUCKET_LABELS: Record<FirstListedBucket, string> = {
  under30: "< 30d",
  d30to90: "30 – 90d",
  d90to180: "90 – 180d",
  over180: "180d +",
};
